import React from "react";

import ScreenLayout from "components/ScreenLayout";
import ClientsTable from "screens/Clients/components/ClientsTable";

import clientsHeaderComponents from "screens/Clients/components/clientsHeaderComponents";

const Clients = () => {
  return (
    <ScreenLayout headerComponents={clientsHeaderComponents}>
      <ClientsTable />
    </ScreenLayout>
  );
};

export default Clients;

